/* import __COLOCATED_TEMPLATE__ from './company-list.hbs'; */
/* RESPONSIBLE TEAM: team-conversations */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/no-actions-hash */
/* eslint-disable @intercom/intercom/no-component-inheritance */
import { equalToProperty } from '@intercom/pulse/lib/computed-properties';
import UserOrCompaniesListComponent from 'embercom/components/base/user-or-companies-list';
import Company from 'embercom/models/company';
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';

export default UserOrCompaniesListComponent.extend({
  attributeService: service(),
  store: service(),
  displayedAttributes: computed('attributeService.displayedCompanyAttributes.[]', function () {
    let displayedCompanyAttributes = this.attributeService.get('displayedCompanyAttributes');
    return displayedCompanyAttributes.filter((attr) => attr.get('identifier') !== 'company.name');
  }),
  companyNameDisplayedAttribute: computed('attributeService.displayableAttributes.[]', function () {
    return this.attributeService
      .get('displayableAttributes')
      .find((attr) => attr.get('identifier') === 'company.name');
  }),
  isShowingAll: equalToProperty('totalCount', 'app.company_count'),

  didInsertElement() {
    this._super(...arguments);
    this._ensureCompanyNameAttributeSetting();
  },

  _ensureCompanyNameAttributeSetting() {
    let companyNameAttribute = this.companyNameDisplayedAttribute;
    if (!companyNameAttribute) {
      return;
    }

    let existingSetting = companyNameAttribute.getAttributeSettingByDisplayOn('companies');
    if (existingSetting) {
      return;
    }

    let newAttributeSetting = this.store.createRecord('display-attribute-setting', {
      app_id: this.get('app.id'),
      attribute: companyNameAttribute.attribute.get('identifier'),
      display_on: 'companies',
    });
    this.get('app.attribute_settings').pushObject(newAttributeSetting);
    newAttributeSetting.save();
  },

  loadPage(page) {
    return this.executeSearch(Company, 'companies', { page });
  },

  tagTypeLabel: 'company',
  tagEndpoint: '/ember/companies/bulk_tag.json',

  actions: {
    showUserOrCompany(company) {
      this.router.transitionTo('apps.app.companies.company', company.id);
    },
    import() {},
    showCreateUserModal() {},
  },
});
